import { ONELINK_MOBILE_APP_URL } from "constants/links";
export default {
    buttonText: "Download App",
    defaultMobileURL: ONELINK_MOBILE_APP_URL,
    defaultDesktopURL: "/"
};
